/* eslint-disable react/jsx-key */
import React from 'react';
import { useSelector } from 'react-redux';
import { selectVisibleFinishedCommands, selectVisibleUnfinishedCommands } from 'store/FileUploaderContext/selector';
import {
  Wrapper, FileWrapper, FileName, Text,
  Commands
} from './styled';
import Status from './Status';
import isEmpty from 'lodash/isEmpty';
import { isGroupingCommandType } from 'Common/Components/FileUploadContext/groupingCommands';
import { getGroupingWorkspaceName } from 'Common/Components/FileUploadContext/groupingPolling/utils';

const renderFileName = (file) => {
  if (isGroupingCommandType(file.commandType)) {
    const workspaceName = getGroupingWorkspaceName(file);
    return <FileName title={ workspaceName } children={ workspaceName } commandType={ file.commandType } />;
  }

  if (file.commandType === 'moveAssets') {
    return <FileName title="Moving Assets..." children="Moving Assets..." commandType={ file.commandType } />;
  }

  return <FileName title={ file.name } children={ file.name } />;
};

const Body = () => {
  const unfinishedCommands = useSelector((state) => selectVisibleUnfinishedCommands(state));
  const finishedCommands = useSelector((state) => selectVisibleFinishedCommands(state));

  if (isEmpty(unfinishedCommands) && isEmpty(finishedCommands)) {
    return (
    <Wrapper>
      <Text>The queue is empty</Text>
    </Wrapper>
    );
  }
  return (
    <Wrapper>
      { unfinishedCommands && (
        <Commands>
          { unfinishedCommands.map((file, i) => (
            <FileWrapper key={ `${file.name}_${i}` }>
              { renderFileName(file) }
              <Status file={ file } />
            </FileWrapper>
          )) }
        </Commands>
      ) }

      { finishedCommands && (
        <Commands>
          { finishedCommands.map((file, i) => (
            <FileWrapper key={ `${file.name}_${i}` }>
              { isGroupingCommandType(file.commandType) || !file.commandType ? renderFileName(file) : null }
              <Status file={ file } />
            </FileWrapper>
          )) }
        </Commands>
      ) }
    </Wrapper>
  );
};

export default Body;
